import React from 'react';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormInput from 'components/forms/FormInput';
import FormLangRichEditor from 'components/forms/FormLangRichEditor';
import FormSwitchery from 'components/forms/FormSwitchery';

class MainMenuVersionData extends EntityPropsUpdater {
  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      disabled,
      inModal,
    } = this.props;

    return (
      <div class="clearfix">
        {entityLoaded && (
          <div>
            <Row>
              <Col xs={12} md={inModal ? 12 : 6}>
                <div class="panel panel-transparent">
                  <div class="panel-body">
                    <p className="form-group-title">{messages.formGroup.basic_information}</p>
                    <div class="form-group-attached">
                      <FormInput
                        label="ID"
                        name="id"
                        value={entity.getId()}
                        meta={entity.getIdMetaInformation()}
                        validation={entity.getIdValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled || !inModal}
                      />
                      <FormInput
                        name="name"
                        label={messages.name}
                        value={entity.getName()}
                        meta={entity.getNameMetaInformation()}
                        validation={entity.getNameValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                      <div class="form-group form-group-default padding-10">
                        <FormSwitchery
                          name="hasSecondaryElements"
                          label={messages.has_secondary_elements}
                          checked={entity.getHasSecondaryElements()}
                          meta={entity.getHasSecondaryElementsMetaInformation()}
                          validation={entity.getHasSecondaryElementsValidationResult()}
                          value
                          onChange={this.updateEntity}
                        />
                      </div>
                      <FormLangRichEditor
                        name="description"
                        label={messages.description}
                        value={entity.getDescription()}
                        meta={entity.getDescriptionMetaInformation()}
                        validation={entity.getDescriptionValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  }
}
MainMenuVersionData.defaultProps = {
  inModal: false,
};

export default injectIntl(MainMenuVersionData);
